var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.copied)?_c('div',[_c('span',{staticClass:"fas fa-check text-success"}),_c('small',{staticClass:"text-success"},[_vm._v(" Copiado!")])]):_c('button',{staticClass:"btn btn-sm btn-white lift",on:{"click":_vm.copy}},[_c('i',{staticClass:"fa-regular fa-copy"})])
}
var staticRenderFns = []

export { render, staticRenderFns }